import React from "react";
import "./styles.css"; // Import your CSS file

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./home";

/* <Route path="/about" component={About} />
<Route path="/contact" component={Contact} /> */

export default function App() {
  return (
    //  <Home />
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/path-recommendation" />
      </Routes>
    </Router>
  );
}
